import { BffResponseRetrofitAdapter } from 'stores/adapters/bex-api/migration-adapters';

import { ResultType } from 'constants/resultType';

import { FullPropertySearch } from '__generated__/api';

export const splitMessagesFromLodging: BffResponseRetrofitAdapter = searchResults =>
  searchResults && Array.isArray(searchResults.hotels)
    ? {
        ...searchResults,
        ...searchResults.hotels.reduce(
          (accumulator, listing, index) => {
            switch (listing.resultType) {
              case ResultType.HOTEL:
                accumulator.hotels.push(listing);
                break;
              case ResultType.LIST_TITLE:
                accumulator.resultSectionHeadings.push({
                  heading: listing && listing.model && listing.model.titleModel && listing.model.titleModel.text,
                  index
                });
                break;
              default:
                accumulator.messages.push({ ...listing, index });
            }

            return accumulator;
          },
          { hotels: [], messages: [], resultSectionHeadings: [] as FullPropertySearch.ResultSectionHeadings[] }
        )
      }
    : { ...searchResults, hotels: [], messages: [], resultSectionHeadings: [] as FullPropertySearch.ResultSectionHeadings[] };
